import React from "react";

function Homepage() {
  return <p>Home Page</p>;
}

export default Homepage;
